import { useAppDispatch } from 'hooks/useAppDispatch';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import {
  getVerificationStatusAction,
  getVerificationStatusEmploymentAction,
  getVerificationStatusIdAction,
  getVerificationStatusInvestLongAction,
  getVerificationStatusInvestorLevelAction,
  getVerificationStatusInvestShortAction,
  getVerificationStatusPorAction,
  getVerificationStatusSourceAction,
  getVerificationStatusUseOfFundsAction,
  submitVerificationFieldsAttachment,
  submitVerificationFieldsEmployment,
  submitVerificationFieldsFunds,
  submitVerificationFieldsId,
  submitVerificationFieldsLevel,
  submitVerificationFieldsLongInvest,
  submitVerificationFieldsPor,
  submitVerificationFieldsPorAttachment,
  submitVerificationFieldsShortInvest,
  submitVerificationFieldsSource,
} from '../store/verification/verification-actions';
import {
  SubmitVerificationInfo,
  VerificationStatusResponse,
} from '../types/verification';

const useGetVerificationStatus = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusAction());
  }, [dispatch]);

  const data = useSelector((state: RootState) => state.verification.status);

  return data;
};

const useGetVerificationStatusUseOfFunds = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusUseOfFundsAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepFunds,
  );

  return data;
};

const useGetVerificationStatusInvestShort = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusInvestShortAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepInvestShort,
  );

  return data;
};

const useGetVerificationStatusInvestLong = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusInvestLongAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepInvestLong,
  );

  return data;
};

const useGetVerificationStatusEmployment = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusEmploymentAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepEmployment,
  );

  return data;
};

const useGetVerificationStatusInvestorLevel = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusInvestorLevelAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepInvestorLevel,
  );

  return data;
};

const useGetVerificationStatusSource = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusSourceAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepSource,
  );

  return data;
};

const useGetVerificationStatusPor = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusPorAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepPOR,
  );

  return data;
};

const useGetVerificationStatusId = () => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(getVerificationStatusIdAction());
  }, [dispatch]);

  const data = useSelector(
    (state: RootState) => state.verification.verificationStepID,
  );

  return data;
};

const useSubmitVerificationFunds = () => {
  const dispatch = useAppDispatch();

  const submitVerificationFunds = async (request: SubmitVerificationInfo) => {
    await dispatch(submitVerificationFieldsFunds(request));
  };

  return [submitVerificationFunds];
};

const useSubmitVerificationShortInvest = () => {
  const dispatch = useAppDispatch();

  const submitVerificationShortInvest = async (
    request: SubmitVerificationInfo,
  ) => {
    await dispatch(submitVerificationFieldsShortInvest(request));
  };

  return [submitVerificationShortInvest];
};

const useSubmitVerificationLongInvest = () => {
  const dispatch = useAppDispatch();

  const submitVerificationLongInvest = async (
    request: SubmitVerificationInfo,
  ) => {
    await dispatch(submitVerificationFieldsLongInvest(request));
  };

  return [submitVerificationLongInvest];
};

const useSubmitVerificationEmployment = () => {
  const dispatch = useAppDispatch();

  const submitVerificationEmployment = async (
    request: SubmitVerificationInfo,
  ) => {
    await dispatch(submitVerificationFieldsEmployment(request));
  };

  return [submitVerificationEmployment];
};

const useSubmitVerificationLevel = () => {
  const dispatch = useAppDispatch();

  const submitVerificationLevel = async (request: SubmitVerificationInfo) => {
    await dispatch(submitVerificationFieldsLevel(request));
  };

  return [submitVerificationLevel];
};

const useSubmitVerificationSource = () => {
  const dispatch = useAppDispatch();

  const submitVerificationSource = async (request: SubmitVerificationInfo) => {
    await dispatch(submitVerificationFieldsSource(request));
  };

  return [submitVerificationSource];
};

const useSubmitVerificationAttachment = () => {
  const dispatch = useAppDispatch();

  const submitVerificationAttachment = async (request: File) => {
    await dispatch(submitVerificationFieldsAttachment(request));
  };

  return [submitVerificationAttachment];
};

const useSubmitVerificationPor = () => {
  const dispatch = useAppDispatch();

  const submitVerificationPor = async (request: SubmitVerificationInfo) => {
    await dispatch(submitVerificationFieldsPor(request));
  };

  return [submitVerificationPor];
};

const useSubmitVerificationPorAttachment = () => {
  const dispatch = useAppDispatch();

  const submitVerificationPorAttachment = async (
    request: File,
    callback?: (response: VerificationStatusResponse) => void,
  ) => {
    await dispatch(submitVerificationFieldsPorAttachment(request, callback));
  };

  return [submitVerificationPorAttachment];
};

const useSubmitVerificationId = () => {
  const dispatch = useAppDispatch();

  const submitVerificationid = async (request: SubmitVerificationInfo) => {
    await dispatch(submitVerificationFieldsId(request));
  };

  return [submitVerificationid];
};

export {
  useGetVerificationStatus, useGetVerificationStatusEmployment, useGetVerificationStatusId, useGetVerificationStatusInvestLong, useGetVerificationStatusInvestorLevel, useGetVerificationStatusInvestShort, useGetVerificationStatusSource, useGetVerificationStatusUseOfFunds, useSubmitVerificationEmployment, useSubmitVerificationFunds, useSubmitVerificationLevel, useSubmitVerificationLongInvest,
  useSubmitVerificationShortInvest, useSubmitVerificationSource
};

